import _objectSpread from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import * as React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var propTypes = {
  /** An accessible label indicating the relevant information about the Close Button. */
  'aria-label': PropTypes.string,
  /** A callback fired after the Close Button is clicked. */
  onClick: PropTypes.func,
  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: PropTypes.oneOf(['white'])
};
var CloseButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    variant = _ref.variant,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Close' : _ref$ariaLabel,
    props = _objectWithoutProperties(_ref, ["className", "variant", "aria-label"]);
  return /*#__PURE__*/_jsx("button", _objectSpread({
    ref: ref,
    type: "button",
    className: classNames('btn-close', variant && "btn-close-".concat(variant), className),
    "aria-label": ariaLabel
  }, props));
});
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
export default CloseButton;